(function () {

    var baseUrl = "https://biogaia.infolyzer.se";
    var assetsBaseUrl = `${baseUrl}/assets`;
    var apiBaseUrl = `${baseUrl}/api`;
    var quizzesBaseUrl = `${baseUrl}/quizzes/mini-quizzes`;

    var version = Date.now().toString();

    results = {};
    quizContainers = document.querySelectorAll("[data-mini-quiz-id]");

    quizContainers.forEach(async quizContainer => {
        var quizId = quizContainer.getAttribute("data-mini-quiz-id");
        var response = await fetch(`${quizzesBaseUrl}/${quizId}/mini-quiz.json?v=${version}`);
        var quizData = await response.json();
        await init(quizId, quizData, quizContainer);
    });

    async function init(quizId, quizData, quizContainer) {
        results[quizId] = {
            answers: [],
            average: 0,
            respondents: 0
        };
        var response = await fetch(`${apiBaseUrl}/get.php?quiz-id=${quizId}`);
        var stats = await response.json();
        results[quizId].average = parseInt(stats.average);
        results[quizId].respondents = parseInt(stats.respondents);

        var pageContainer = _createDiv("bgq-mini-page-container");
        quizContainer.appendChild(pageContainer);
        var page = _createDiv("page");
        pageContainer.appendChild(page);
        var imageUrl = `${quizzesBaseUrl}/${quizId}/${quizData.mediaUrl}`
        page.style.backgroundImage = `url("${imageUrl}")`;

        var panel = _createDiv("panel");
        page.appendChild(panel);

        var title = _createDiv("title");
        panel.appendChild(title);
        title.innerText = "QUICK QUESTION";

        var question = _createDiv("question");
        panel.appendChild(question);
        question.innerHTML = quizData.question;

        var optionContainer = _createDiv("option-container");
        panel.appendChild(optionContainer);

        var answer = _createDiv("answer");
        panel.appendChild(answer);

        var readMore = _createDiv("read-more");
        panel.appendChild(readMore);

        var i = 1;
        quizData.alternatives.forEach(alternative => {
            var option = _createDiv("option active");
            optionContainer.appendChild(option);
            option.setAttribute("data-alternative", i);
            var radioButton = _createDiv("radio-button");
            option.appendChild(radioButton);
            radioButton.appendChild(_createDiv()); // To create the white bg with transparent border/padding
            var optionText = _createDiv("option-text");
            option.appendChild(optionText);
            optionText.innerHTML = alternative;

            option.addEventListener("click", async function () {
                // Prevent further clicks on this optionContainer after the first click (until reset)
                if (page.classList.contains("answered")) {
                    return;
                }
                page.classList.add("answered");

                var selectedAlternative = parseInt(this.getAttribute("data-alternative"));
                var correct = selectedAlternative === quizData.correctAlternative;

                // record the answer
                results[quizId].answers.push(correct);

                // mark correct/incorrect
                setTimeout(() => {
                    optionContainer.querySelectorAll(".option").forEach(op => {
                        op.classList.remove("active");
                        var opIndex = parseInt(op.getAttribute("data-alternative"));
                        if (opIndex === quizData.correctAlternative) {
                            op.classList.add("correct");
                        } else {
                            op.classList.add("incorrect");
                        }
                    });
                    answer.innerHTML = correct ? quizData.correctAnswer : quizData.wrongAnswer;
                    if (quizData.readMore) {
                        readMore.innerHTML = _renderReadMore(quizData.readMore);
                    }
                }, 250);

                option.classList.add("selected");

                await _updateResult(quizId)
            });

            i++;
        });
    }

    function _createDiv(classNames) {
        var div = document.createElement("div");
        if (classNames) {
            var classes = classNames.split(" ");
            classes.forEach(c => div.classList.add(c));
        }
        return div;
    }

    var replaceLinkIndex;

    function _renderReadMore(readMoreData) {
        replaceLinkIndex = 0;
        return readMoreData.text.replace(/({{)([^}}]+)(}})/g, function (match) {
            var linkText = match.substr(2, match.length - 4);
            var url = readMoreData.links[replaceLinkIndex++];
            return `<a href="${url}" target="_blank" class="read-more">${linkText}</a>`;
        });
    }

    async function _updateResult(quizId) {
        var result = results[quizId];
        var correctAnswers = result.answers.filter(a => a === true).length;
        await _postResult({
            quizId,
            correctAnswers,
            numberOfQuestions: result.answers.length,
            answersJson: JSON.stringify({ answers: result.answers })
        })
    }

    async function _postResult(data) {
        try {
            var response = await fetch(`${apiBaseUrl}/post.php`, {
                method: "POST",
                headers: {
                },
                body: JSON.stringify(data),
            });
            const result = await response.json();
            console.log("Success:", result);
        } catch (error) {
            console.error("Error:", error);
        }
    }

})();
